import React, { useState } from "react";
import { Card, CardBody, Col, Collapse, Row, Container } from "reactstrap";
import classnames from "classnames";
import Divider from "./Divider";

const Faq = ({ eventDetails }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <React.Fragment>
      <div className="faq-section py-4 py-md-5">
        <Container fluid className="px-3 px-md-4 px-lg-5">
          {/* FAQ Heading */}
          <Row className="justify-content-center mb-4 mb-md-5">
            <Col xs={12}>
              <h1
                id="faq"
                className="text-center mb-3 fw-bold"
                style={{ 
                  color: "#1a1a1a",
                  fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
                  letterSpacing: "-0.5px"
                }}
              >
                FAQ
              </h1>
              <div className="d-flex justify-content-center">
                <Divider />
              </div>
            </Col>
          </Row>
          
          {/* FAQ Content */}
          <Row className="justify-content-center">
            <Col xs={12} sm={12} md={11} lg={10} xl={9}>
              <div className="mt-3 mt-md-4">
                <Card className="border-0 shadow">
                  <CardBody className="p-3 p-md-4 p-lg-5">
                    <div className="accordion-container">
                      {eventDetails?.faq?.map(
                        (faq, index) =>
                          faq.question &&
                          faq.answer && (
                            <div 
                              className="faq-item mb-3" 
                              key={faq._id || index}
                              style={{
                                border: "1px solid #e9ecef",
                                borderRadius: "12px",
                                overflow: "hidden",
                                transition: "all 0.3s ease"
                              }}
                            >
                              {/* Question Header */}
                              <button
                                className={classnames(
                                  "faq-header w-100 d-flex justify-content-between align-items-center p-3 p-md-4",
                                  {
                                    "active": openIndex === index,
                                  }
                                )}
                                onClick={() => toggle(index)}
                                style={{
                                  background: openIndex === index ? "#f8f9fa" : "#ffffff",
                                  border: "none",
                                  cursor: "pointer",
                                  textAlign: "left",
                                  transition: "all 0.3s ease"
                                }}
                                type="button"
                              >
                                <span 
                                  className="faq-question fw-semibold flex-grow-1 pe-3"
                                  style={{
                                    fontSize: "clamp(0.95rem, 3.5vw, 1.05rem)",
                                    lineHeight: "1.5",
                                    color: "#2c3e50",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    hyphens: "auto"
                                  }}
                                >
                                  {faq.question}
                                </span>
                                <span 
                                  className="faq-icon flex-shrink-0"
                                  style={{
                                    fontSize: "1.25rem",
                                    color: "#6c757d",
                                    transition: "transform 0.3s ease",
                                    transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                                    minWidth: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                  }}
                                >
                                  ▼
                                </span>
                              </button>
                              
                              {/* Answer Content */}
                              <Collapse isOpen={openIndex === index}>
                                <div 
                                  className="faq-answer p-3 p-md-4 pt-0"
                                  style={{
                                    borderTop: "1px solid #e9ecef",
                                    background: "#fafbfc"
                                  }}
                                >
                                  <p 
                                    className="mb-0 text-secondary"
                                    style={{
                                      fontSize: "clamp(0.9rem, 3vw, 1rem)",
                                      lineHeight: "1.7",
                                      color: "#495057",
                                      wordWrap: "break-word",
                                      overflowWrap: "break-word"
                                    }}
                                  >
                                    {faq.answer}
                                  </p>
                                </div>
                              </Collapse>
                            </div>
                          )
                      )}
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <style jsx>{`
        .faq-section {
          background-color: #f8f9fa;
        }
        
        .faq-item {
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        
        .faq-item:hover {
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        .faq-header {
          outline: none;
        }
        
        .faq-header:focus {
          outline: 2px solid #0d6efd;
          outline-offset: -2px;
        }
        
        .faq-header.active {
          background-color: #f8f9fa;
        }
        
        .faq-icon {
          color: #6c757d;
          transition: all 0.3s ease;
        }
        
        .faq-header.active .faq-icon {
          color: #0d6efd;
        }
        
        @media (max-width: 576px) {
          .faq-section {
            padding: 2rem 0;
          }
          
          .faq-item {
            margin-bottom: 1rem !important;
          }
          
          .faq-header {
            padding: 1.25rem 1rem !important;
          }
          
          .faq-answer {
            padding: 1rem !important;
            padding-top: 0 !important;
          }
        }
        
        @media (min-width: 768px) {
          .faq-item {
            margin-bottom: 1.25rem !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default Faq;